/**
 * List of countries (ISO three letter country codes) that should use Adyen for brand onboarding
 */
export const ADYEN_BRAND_ONBOARDING_COUNTRIES = 'ADYEN_BRAND_ONBOARDING_COUNTRIES';
